module.exports = __webpack_public_path__ + "img/8.2054b616.png";